export const laoHotelMessaging: Record<string, string> = {
  Assistant: 'ຜູ້ຊ່ວຍອັດຕະໂນມັດ',
  'Waiting for staff': 'ລໍຖ້າພະນັກງານ',
  'Staff replying': 'ພະນັກງານດູແລ',
  'Handled by': 'ຜູ້ດູແລແຊັດ',
  'Reply now': 'ຕອບທັນທີ',
  'No assistant conversations': 'ບໍ່ມີແຊັດທີ່ຜູ້ຊ່ວຍດູແລຢູ່',
  'No guests waiting for staff': 'ບໍ່ມີແຂກລໍຖ້າພະນັກງານ',
  'New conversations will appear here automatically.': 'ການສົນທະນາໃໝ່ຈະປາກົດທີ່ນີ້ອັດຕະໂນມັດ.',
  'Waiting for our hotel team': 'ລໍຖ້າທີມງານໂຮງແຮມຂອງເຮົາ',
  'Send a reply to take over this chat. The assistant will pause; future messages go to your team.':
    'ສົ່ງຂໍ້ຄວາມຕອບເພື່ອຮັບດູແລແຊັດນີ້. ຜູ້ຊ່ວຍອັດຕະໂນມັດຈະຢຸດຕອບ ແລະ ຂໍ້ຄວາມໃໝ່ຈະສົ່ງໃຫ້ທີມງານ.',
  'Thank you for your patience. Please wait for our hotel team to reply here.':
    'ຂໍຂອບໃຈສຳລັບຄວາມອົດທົນຂອງທ່ານ. ກະລຸນາລໍຖ້າພະນັກງານໂຮງແຮມຕອບກັບທ່ານໃນແຊັດນີ້.',
  'Before we start': 'ກ່ອນເລີ່ມສົນທະນາ',
  'Asked what to book': 'ຖາມວ່າຕ້ອງການຈອງຫຍັງ',
  'Use the same chat link in your WhatsApp greeting and Messenger Instant Reply. Customers can leave a number for follow-up.':
    'ໃຊ້ລິ້ງແຊັດດຽວກັນໃນຂໍ້ຄວາມຕ້ອນຮັບ WhatsApp ແລະ ການຕອບອັດຕະໂນມັດ Messenger. ລູກຄ້າສາມາດຝາກເບີເພື່ອໃຫ້ຕິດຕໍ່ກັບ.',
  'Reload details': 'ໂຫຼດຂໍ້ມູນຄືນ',
  'Allow cookies for this website to remember your chat.':
    'ກະລຸນາອະນຸຍາດຄຸກກີໃຫ້ເວັບໄຊນີ້ເພື່ອຈື່ການສົນທະນາຂອງທ່ານ.',
  'Your contact details': 'ຂໍ້ມູນຕິດຕໍ່ຂອງທ່ານ',
  'Preferred name': 'ຊື່ທີ່ຢາກໃຫ້ເຮົາເອີ້ນ',
  'Phone or WhatsApp number (optional)': 'ເບີໂທ ຫຼື WhatsApp (ບໍ່ບັງຄັບ)',
  'Tell us what to call you. You can leave a number if you would like our team to follow up.':
    'ບອກຊື່ທີ່ຢາກໃຫ້ເຮົາເອີ້ນ. ທ່ານສາມາດຝາກເບີໄວ້ເພື່ອໃຫ້ທີມງານຕິດຕໍ່ກັບ.',
  'Lao number, or include your country code. No OTP or password needed.':
    'ໃສ່ເບີລາວ ຫຼື ເພີ່ມລະຫັດປະເທດ. ບໍ່ຕ້ອງໃຊ້ OTP ຫຼື ລະຫັດຜ່ານ.',
  'Contact me by': 'ຕິດຕໍ່ຂ້ອຍຜ່ານ',
  'Phone call': 'ໂທລະສັບ',
  'Our team may use this number to follow up on this conversation.':
    'ຂ້ອຍອະນຸຍາດໃຫ້ທີມງານໃຊ້ເບີນີ້ເພື່ອຕິດຕໍ່ກັບກ່ຽວກັບການສົນທະນານີ້.',
  'This browser remembers your chat for up to 180 days. On a shared device, use “Forget this chat” when you finish.':
    'ບຣາວເຊີນີ້ຈະຈື່ການສົນທະນາໄດ້ສູງສຸດ 180 ວັນ. ຖ້າໃຊ້ອຸປະກອນຮ່ວມກັບຜູ້ອື່ນ ໃຫ້ກົດ “ລືມການສົນທະນານີ້” ເມື່ອສຳເລັດ.',
  'Start chatting': 'ເລີ່ມສົນທະນາ',
  'Save details': 'ບັນທຶກຂໍ້ມູນ',
  'Contact details': 'ຂໍ້ມູນຕິດຕໍ່',
  'Forget this chat': 'ລືມການສົນທະນານີ້',
  'Forget this chat?': 'ລືມການສົນທະນານີ້ບໍ?',
  'This removes access to this conversation from this browser. Using the same name and number starts a new chat, not the old history. Our team keeps the previous case for follow-up.':
    'ການນີ້ຈະລຶບສິດເຂົ້າເບິ່ງການສົນທະນາຈາກບຣາວເຊີນີ້. ແມ່ນແຕ່ໃຊ້ຊື່ ແລະ ເບີເດີມກໍຈະເລີ່ມແຊັດໃໝ່, ບໍ່ແມ່ນປະຫວັດເກົ່າ. ທີມງານຍັງເກັບກໍລະນີເກົ່າໄວ້ເພື່ອຕິດຕໍ່ກັບ.',
  'After forgetting a chat, the same name and number starts a new conversation. Previous messages are not restored.':
    'ຫຼັງຈາກລືມແຊັດ, ການໃຊ້ຊື່ ແລະ ເບີເດີມຈະເລີ່ມການສົນທະນາໃໝ່. ຂໍ້ຄວາມເກົ່າຈະບໍ່ຖືກກູ້ຄືນ.',
  'Follow up on WhatsApp': 'ຕິດຕໍ່ກັບຜ່ານ WhatsApp',
  'Call guest': 'ໂທຫາແຂກ',
  'Guest-provided number · not verified': 'ເບີທີ່ແຂກໃຫ້ · ຍັງບໍ່ໄດ້ຢືນຢັນ',
  'Callback permitted for this conversation': 'ອະນຸຍາດໃຫ້ຕິດຕໍ່ກັບກ່ຽວກັບການສົນທະນານີ້',
  'No callback permission shared': 'ຍັງບໍ່ອະນຸຍາດໃຫ້ຕິດຕໍ່ກັບ',
  'Enter a Lao number or include the country code, for example +856 20 1234 5678.':
    'ໃສ່ເບີລາວ ຫຼື ເພີ່ມລະຫັດປະເທດ, ເຊັ່ນ +856 20 1234 5678.',
  'Allow our team to contact you about this conversation, or leave the number blank.':
    'ອະນຸຍາດໃຫ້ທີມງານຕິດຕໍ່ກັບກ່ຽວກັບການສົນທະນານີ້ ຫຼື ປະໄວ້ຫວ່າງ.',
  'Your contact details changed in another tab. Please reload them.':
    'ຂໍ້ມູນຕິດຕໍ່ຖືກປ່ຽນໃນແທັບອື່ນ. ກະລຸນາໂຫຼດຄືນ.',
  'Virtual assistant': 'ຜູ້ຊ່ວຍອັດຕະໂນມັດ',
  'Virtual assistant · here to help': 'ຜູ້ຊ່ວຍອັດຕະໂນມັດ · ຍິນດີຊ່ວຍທ່ານ',
  'Connecting you with our team…': 'ກຳລັງສົ່ງຕໍ່ໃຫ້ທີມງານຂອງເຮົາ…',
  'With our hotel team': 'ທີມງານໂຮງແຮມກຳລັງດູແລທ່ານ',
  'Sent to our hotel team': 'ສົ່ງໃຫ້ທີມງານໂຮງແຮມແລ້ວ',
  'Write a message…': 'ຂຽນຂໍ້ຄວາມ…',
  'Latest messages': 'ຂໍ້ຄວາມຫຼ້າສຸດ',
  Sent: 'ສົ່ງແລ້ວ',

  'Your question has been sent to our hotel team. A teammate will reply here; there’s no need to repeat it.':
    'ສົ່ງຄຳຖາມຂອງທ່ານໃຫ້ທີມງານໂຮງແຮມແລ້ວ. ພະນັກງານຈະຕອບທີ່ນີ້; ທ່ານບໍ່ຕ້ອງຖາມຊ້ຳ.',
  'Sending your question to our hotel team…': 'ກຳລັງສົ່ງຄຳຖາມໃຫ້ທີມງານໂຮງແຮມ…',
  'Your question hasn’t reached our team yet.': 'ຄຳຖາມຂອງທ່ານຍັງບໍ່ຮອດທີມງານ.',
  'We couldn’t send your question to our team. Please retry.':
    'ສົ່ງຄຳຖາມໃຫ້ທີມງານບໍ່ສຳເລັດ. ກະລຸນາລອງອີກຄັ້ງ.',
  'Guest experience': 'ປະສົບການຂອງແຂກ',
  'Guest messages': 'ຂໍ້ຄວາມຈາກແຂກ',
  'Every guest conversation. A personal reply. One connected stay.':
    'ຮວມການສົນທະນາກັບແຂກ ແລະ ຕອບກັບຢ່າງເອົາໃຈໃສ່ໃນບ່ອນດຽວ.',
  'Instant answers for your guests, with your team a message away.':
    'ຕອບຄຳຖາມແຂກທັນທີ ແລະ ໃຫ້ແຂກຕິດຕໍ່ທີມງານໄດ້ງ່າຍ.',
  'Booking page inbox': 'ກ່ອງຂໍ້ຄວາມຈາກໜ້າຈອງ',
  'Updates automatically': 'ອັບເດດອັດຕະໂນມັດ',
  'Share guest links': 'ແບ່ງປັນລິ້ງໃຫ້ແຂກ',
  'Guest links': 'ລິ້ງສຳລັບແຂກ',
  'Booking page': 'ໜ້າຈອງ',
  'Open guest page': 'ເປີດໜ້າສຳລັບແຂກ',
  'Publish your booking page so guests can book and message your team.':
    'ເຜີຍແຜ່ໜ້າຈອງ ເພື່ອໃຫ້ແຂກຈອງ ແລະ ສົ່ງຂໍ້ຄວາມຫາທີມງານ.',
  'Turn on the chat assistant to let guests message your team.':
    'ເປີດຜູ້ຊ່ວຍແຊັດ ເພື່ອໃຫ້ແຂກສົ່ງຂໍ້ຄວາມຫາທີມງານ.',
  'Set up': 'ຕັ້ງຄ່າ',
  Inbox: 'ກ່ອງຂໍ້ຄວາມ',
  'Guest conversations': 'ການສົນທະນາກັບແຂກ',
  'Search conversations': 'ຄົ້ນຫາການສົນທະນາ',
  'Search guests or messages': 'ຄົ້ນຫາແຂກ ຫຼື ຂໍ້ຄວາມ',
  'Filter conversations': 'ກັ່ນຕອງການສົນທະນາ',
  Unread: 'ຍັງບໍ່ອ່ານ',
  unread: 'ຍັງບໍ່ອ່ານ',
  Mine: 'ຂອງຂ້ອຍ',
  Resolved: 'ແກ້ໄຂແລ້ວ',
  Resolve: 'ໝາຍວ່າແກ້ໄຂແລ້ວ',
  Reopen: 'ເປີດຄືນ',
  Unassigned: 'ຍັງບໍ່ມອບໝາຍ',
  'Unread counts are personal to you': 'ຈຳນວນທີ່ຍັງບໍ່ອ່ານເປັນຂອງທ່ານເອງ',
  'unread messages': 'ຂໍ້ຄວາມທີ່ຍັງບໍ່ອ່ານ',
  'No matching conversations': 'ບໍ່ພົບການສົນທະນາທີ່ກົງກັນ',
  'You’re all caught up': 'ທ່ານອ່ານຄົບແລ້ວ',
  'No resolved conversations': 'ຍັງບໍ່ມີການສົນທະນາທີ່ແກ້ໄຂແລ້ວ',
  'No conversations assigned to you': 'ຍັງບໍ່ມີການສົນທະນາທີ່ມອບໝາຍໃຫ້ທ່ານ',
  'Your guest conversations start here': 'ການສົນທະນາກັບແຂກເລີ່ມຕົ້ນທີ່ນີ້',
  'Try another guest name or message.': 'ລອງຄົ້ນຫາຊື່ແຂກ ຫຼື ຂໍ້ຄວາມອື່ນ.',
  'Guests can message you from the booking page. Share a link to start a conversation.':
    'ແຂກສາມາດສົ່ງຂໍ້ຄວາມຈາກໜ້າຈອງ. ແບ່ງປັນລິ້ງເພື່ອເລີ່ມສົນທະນາ.',
  'A personal welcome starts here': 'ການຕ້ອນຮັບທີ່ເອົາໃຈໃສ່ເລີ່ມຕົ້ນທີ່ນີ້',
  'Help your guests feel at home.': 'ໃຫ້ແຂກຮູ້ສຶກອົບອຸ່ນຄືຢູ່ບ້ານ.',
  'Choose a conversation to answer a question, help with a booking, or share a little local knowledge.':
    'ເລືອກການສົນທະນາເພື່ອຕອບຄຳຖາມ, ຊ່ວຍແຂກຈອງ ຫຼື ແນະນຳຂໍ້ມູນທ້ອງຖິ່ນ.',
  'Direct guest replies': 'ຕອບກັບແຂກໂດຍກົງ',
  'Private team notes': 'ບັນທຶກສ່ວນຕົວຂອງທີມງານ',
  'Stay details in context': 'ລາຍລະອຽດການພັກໃນການສົນທະນາ',
  'Share your booking page': 'ແບ່ງປັນໜ້າຈອງ',
  'Back to inbox': 'ກັບໄປກ່ອງຂໍ້ຄວາມ',
  'Booking page conversation': 'ການສົນທະນາຈາກໜ້າຈອງ',
  'Conversation from your direct booking page': 'ການສົນທະນາຈາກໜ້າຈອງໂດຍກົງ',
  'Updates are delayed. Check your connection.': 'ການອັບເດດຊັກຊ້າ. ກວດສອບອິນເຕີເນັດຂອງທ່ານ.',
  'Load earlier messages': 'ໂຫຼດຂໍ້ຄວາມກ່ອນໜ້າ',
  'Reply to guest': 'ຕອບກັບແຂກ',
  'Internal note': 'ບັນທຶກພາຍໃນ',
  'Only your team can see this note…': 'ມີພຽງທີມງານຂອງທ່ານທີ່ເຫັນບັນທຶກນີ້…',
  'Write a personal reply…': 'ຂຽນຂໍ້ຄວາມຕອບກັບ…',
  'Ask an administrator for permission to reply.': 'ຂໍສິດຕອບກັບຈາກຜູ້ດູແລ.',
  'Booking link': 'ລິ້ງຈອງ',
  'You can choose your room and complete your booking here:':
    'ທ່ານສາມາດເລືອກຫ້ອງ ແລະ ຈອງໃຫ້ສຳເລັດໄດ້ທີ່ນີ້:',
  'Insert quick reply': 'ໃສ່ຄຳຕອບດ່ວນ',
  'Quick replies': 'ຄຳຕອບດ່ວນ',
  'Add note': 'ເພີ່ມບັນທຶກ',
  'Send reply': 'ສົ່ງຄຳຕອບ',
  'Private · visible to your hotel team only': 'ສ່ວນຕົວ · ເຫັນໄດ້ສະເພາະທີມງານໂຮງແຮມ',
  'Replies appear in the guest’s chat.': 'ຄຳຕອບຈະສະແດງໃນແຊັດຂອງແຂກ.',
  'Guest details': 'ລາຍລະອຽດແຂກ',
  'Direct booking guest': 'ແຂກຈອງໂດຍກົງ',
  'Conversation details': 'ລາຍລະອຽດການສົນທະນາ',
  'Assigned to': 'ມອບໝາຍໃຫ້',
  Started: 'ເລີ່ມຕົ້ນ',
  Channel: 'ຊ່ອງທາງ',
  'No email shared': 'ຍັງບໍ່ມີອີເມວ',
  'Guest’s booking details': 'ລາຍລະອຽດການຈອງຂອງແຂກ',
  'Stay details appear when a guest shares them.': 'ລາຍລະອຽດການພັກຈະສະແດງເມື່ອແຂກແບ່ງປັນ.',
  'Details shared by the guest; availability is checked at booking.':
    'ຂໍ້ມູນທີ່ແຂກແບ່ງປັນ; ຈະກວດສອບຫ້ອງຫວ່າງເມື່ອຈອງ.',
  'Keep the journey moving': 'ຊ່ວຍໃຫ້ແຂກຈອງຕໍ່',
  'Let your guest choose a room and finish their reservation online.':
    'ໃຫ້ແຂກເລືອກຫ້ອງ ແລະ ຈອງໃຫ້ສຳເລັດອອນລາຍ.',
  'Copy booking link': 'ຄັດລອກລິ້ງຈອງ',
  'The whole stay in view': 'ເຫັນຂໍ້ມູນການພັກຄົບຖ້ວນ',
  'Guest details and booking dates sit beside every conversation.':
    'ລາຍລະອຽດແຂກ ແລະ ວັນທີຈອງຢູ່ຂ້າງການສົນທະນາ.',
  'Start a guest conversation': 'ເລີ່ມສົນທະນາກັບແຂກ',
  'Your first message': 'ຂໍ້ຄວາມທຳອິດຂອງທ່ານ',
  'Email (optional)': 'ອີເມວ (ບໍ່ບັງຄັບ)',
  'Create & copy private link': 'ສ້າງ ແລະ ຄັດລອກລິ້ງສ່ວນຕົວ',
  'Private guest chat link': 'ລິ້ງແຊັດສ່ວນຕົວສຳລັບແຂກ',
  'Copy private link': 'ຄັດລອກລິ້ງສ່ວນຕົວ',
  'Private chat link copied': 'ຄັດລອກລິ້ງແຊັດສ່ວນຕົວແລ້ວ',
  'Keep this link private. Anyone with the link can access this conversation.':
    'ເກັບລິ້ງນີ້ໄວ້ເປັນສ່ວນຕົວ. ຜູ້ທີ່ມີລິ້ງສາມາດເຂົ້າເຖິງການສົນທະນານີ້ໄດ້.',
  'Your conversation is ready. Share this private link with your guest.':
    'ການສົນທະນາພ້ອມແລ້ວ. ແບ່ງປັນລິ້ງສ່ວນຕົວນີ້ໃຫ້ແຂກ.',
  'Create a private conversation link to send to your guest. They can chat with you and continue to booking.':
    'ສ້າງລິ້ງສົນທະນາສ່ວນຕົວໃຫ້ແຂກ. ແຂກສາມາດແຊັດກັບທ່ານ ແລະ ດຳເນີນການຈອງຕໍ່ໄດ້.',
  'A helpful answer. A confident booking.': 'ຄຳຕອບທີ່ຊ່ວຍໄດ້. ການຈອງທີ່ໝັ້ນໃຈ.',
  'Open guest inbox': 'ເປີດກ່ອງຂໍ້ຄວາມແຂກ',
  'Assistant is turned off': 'ຜູ້ຊ່ວຍຖືກປິດຢູ່',
  'Available on your booking page': 'ພ້ອມໃຊ້ໃນໜ້າຈອງຂອງທ່ານ',
  'Two links. One guest journey.': 'ສອງລິ້ງ ສຳລັບການຈອງທີ່ຕໍ່ເນື່ອງ',
  'Save assistant': 'ບັນທຶກຜູ້ຊ່ວຍ',
  'Assistant settings saved': 'ບັນທຶກການຕັ້ງຄ່າຜູ້ຊ່ວຍແລ້ວ',
  'Publish your booking page to make guest links available.':
    'ເຜີຍແຜ່ໜ້າຈອງ ເພື່ອໃຫ້ແຂກໃຊ້ລິ້ງໄດ້.',
  'Hotel team': 'ທີມງານໂຮງແຮມ',
  'Chat channels': 'ຊ່ອງທາງແຊັດ',
  'Direct messages with our team': 'ສົ່ງຂໍ້ຄວາມຫາທີມງານໂດຍກົງ',
  'Message the hotel team': 'ສົ່ງຂໍ້ຄວາມຫາທີມງານໂຮງແຮມ',
  'Message the hotel team…': 'ຂຽນຂໍ້ຄວາມຫາທີມງານໂຮງແຮມ…',
  'Send message to staff': 'ສົ່ງຂໍ້ຄວາມຫາພະນັກງານ',
  'A little help from our team': 'ຄວາມຊ່ວຍເຫຼືອຈາກທີມງານຂອງເຮົາ',
  'Your name': 'ຊື່ຂອງທ່ານ',
  'Loading conversation…': 'ກຳລັງໂຫຼດການສົນທະນາ…',
  'Replies from': 'ຄຳຕອບຈາກ',
  'Sent to the hotel team. You can continue booking while you wait.':
    'ສົ່ງເຖິງທີມງານໂຮງແຮມແລ້ວ. ທ່ານສາມາດຈອງຕໍ່ໃນລະຫວ່າງລໍຖ້າ.',
  'Your conversation is resolved. Send a message if you need anything else.':
    'ການສົນທະນາແກ້ໄຂແລ້ວ. ສົ່ງຂໍ້ຄວາມໄດ້ຖ້າຕ້ອງການຄວາມຊ່ວຍເຫຼືອເພີ່ມ.',
  'Ask a question or tell us what would make your stay special. Our hotel team will reply here.':
    'ຖາມຄຳຖາມ ຫຼື ບອກເຮົາວ່າທ່ານຕ້ອງການຫຍັງສຳລັບການພັກ. ທີມງານຈະຕອບກັບທີ່ນີ້.',
  'View rooms & book': 'ເບິ່ງຫ້ອງ ແລະ ຈອງ',
  'Find your room': 'ຊອກຫາຫ້ອງຂອງທ່ານ',
  'Your stay, made personal': 'ການພັກທີ່ເອົາໃຈໃສ່ທ່ານ',
  'Direct booking. Personal service.': 'ຈອງໂດຍກົງ. ບໍລິການຢ່າງເອົາໃຈໃສ່.',
  'New guest message': 'ຂໍ້ຄວາມໃໝ່ຈາກແຂກ',
  'Open conversation': 'ເປີດການສົນທະນາ',
  'unread guest messages': 'ຂໍ້ຄວາມຈາກແຂກທີ່ຍັງບໍ່ອ່ານ',
};
